exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.loading-update {\n  height: 1.333333rem;\n  line-height: 1.333333rem;\n  text-align: center;\n  color: #9a9a9a;\n}\n.message_bottom {\n  height: 0.8rem;\n  line-height: 0.8rem;\n  color: #9a9a9a;\n  text-align: center;\n}", "", {"version":3,"sources":["D:/DevelopTest/South/CSWebApp/cstfwh5/src/components/updateLoading.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,mBAAmB;CACpB","file":"updateLoading.vue","sourcesContent":["\n.loading-update {\n  height: 1.333333rem;\n  line-height: 1.333333rem;\n  text-align: center;\n  color: #9a9a9a;\n}\n.message_bottom {\n  height: 0.8rem;\n  line-height: 0.8rem;\n  color: #9a9a9a;\n  text-align: center;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f8105200","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":75}!./node_modules/less-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/updateLoading.vue
// module id = kCDT
// module chunks = 0